// Base URL from environment variable
export const API_BASE_URL = process.env.REACT_APP_BASE_URL;
export const REACT_APP_AZURE_STORAGE_DETAIL = process.env.REACT_APP_AZURE_STORAGE_DETAIL;
export const PYTHON_API_BASE_URL = `${process.env.REACT_APP_PYTHON_BACKEND_URL}/api`; 

// API Endpoints
export const API_ENDPOINTS = {
  // Storage Account
  STORAGE_ACCOUNT: "/api/v1/resources/storage_account",

  // Storage Manager
  STORAGE_MANAGER: "/storage_manager",
  DELETE_MICROGRID: "/storage_manager/delete_microgrid",
  DELETE_DATASETS: "/storage_manager/delete_datasets",
  DELETE_SIMULATION_RESULTS: "/storage_manager/delete_simulation_results",
  UPDATE_SIMULATION_NAME: "/storage_manager/update_simulation_name",

  // Auth
  LOGIN: "/auth/login",
  LOGOUT: "/auth/logout",
};

// Copilot host endpoints (features/copilot/api/). The base URL is read at
// call time by features/copilot/copilotConfig.js, not here.
export const COPILOT_ENDPOINTS = {
  ME: "/v1/me",
  CHAT: "/v1/chat",
  FILES: "/v1/files",
  RUNS: "/v1/runs",
  ONBOARDING: "/v1/onboarding",
};

// API Methods
export const API_METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
};

// API Headers
export const API_HEADERS = {
  "Content-Type": "application/json",
  "x-input-storage-manager-type": "AzureStorageManager",
};
